import React, { PureComponent, ReactElement } from "react";
import styled from "styled-components/macro";
import { SIDELIST_TITLE_BACKGROUND, RESIZER_THICKNESS, BORDER_COLOR } from "../../helpers/Const";

const VerticalResizerRoot = styled.div`
  flex: 0 0 ${RESIZER_THICKNESS}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: row-resize;
  border-top: solid 1px ${BORDER_COLOR};
  border-bottom: solid 1px ${BORDER_COLOR};
  background-color: ${SIDELIST_TITLE_BACKGROUND};
`;

const VerticalResizerInner = styled.div`
  flex: 0 0 auto;
  border-radius: 50%;
  height: 4px;
  width: 4px;
  margin: 0 3px;
  background-color: #fff;
`;

interface IVerticalResizerProps {
  viewIndex: number;
  onTimelineVerticalResizerDrag: (delta: number, viewIndex: number) => void;
}

export default class VerticalResizer extends PureComponent<IVerticalResizerProps> {
  draggingPosition = 0;

  doMouseDown = (e: React.MouseEvent<HTMLElement>): void => {
    if (e.button === 0) {
      this.draggingPosition = e.clientY;
      document.addEventListener("mousemove", this.doMouseMove);
      document.addEventListener("mouseup", this.doMouseUp);
    }
  };

  doMouseMove = (e: MouseEvent): void => {
    const delta = this.draggingPosition - e.clientY;
    this.draggingPosition = e.clientY;
    this.props.onTimelineVerticalResizerDrag(delta, this.props.viewIndex);
  };

  doMouseUp = (_: MouseEvent): void => {
    document.removeEventListener("mousemove", this.doMouseMove);
    document.removeEventListener("mouseup", this.doMouseUp);
  };

  render(): ReactElement {
    return (
      <VerticalResizerRoot onMouseDown={this.doMouseDown}>
        <VerticalResizerInner />
        <VerticalResizerInner />
        <VerticalResizerInner />
        <VerticalResizerInner />
      </VerticalResizerRoot>
    );
  }
}
